import React from "react";

import { Navigate } from "react-router-dom";

import { useAuth } from "@/features/auth/hooks/useAuth";

/**
 * Props for the PrivateRoute component
 */
interface PrivateRouteProps {
  /** Child components to render if user is authenticated */
  children: React.ReactNode;
}

/**
 * Component that protects routes by checking authentication status
 *
 * @param props - Component props
 * @returns Navigate component if not authenticated, children if authenticated
 *
 * @example
 * ```typescript
 * <PrivateRoute>
 *   <Dashboard />
 * </PrivateRoute>
 * ```
 */
export function PrivateRoute({ children }: PrivateRouteProps) {
  const { currentUser } = useAuth();
  // Las sesiones anónimas del link público no cuentan como acceso al panel.
  const isAuthenticated = currentUser !== null && !currentUser.isAnonymous;

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
